// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero_wrapper__iDbLd","heroContent":"Hero_heroContent__2aKTN","heroTitle":"Hero_heroTitle__3ZIMm","contentWrapper":"Hero_contentWrapper__1GawP"};